/* ============ CLENERA THEME — JS ============ */

document.addEventListener('DOMContentLoaded', () => {

  /* FAQ accordion */
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.parentElement;
      const wasOpen = item.classList.contains('open');
      item.parentElement.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if (!wasOpen) item.classList.add('open');
    });
  });

  /* Header shadow on scroll */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 20) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Quantity selector */
  document.querySelectorAll('.qty-input').forEach(wrap => {
    const input = wrap.querySelector('input');
    if (!input) return;
    wrap.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const dir = btn.dataset.dir;
        let val = parseInt(input.value, 10) || 1;
        val = dir === 'up' ? val + 1 : Math.max(1, val - 1);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* Newsletter inline confirmation */
  document.querySelectorAll('.newsletter-form').forEach(form => {
    form.addEventListener('submit', (e) => {
      // If this is a Shopify customer form, let it submit. Otherwise, demo state.
      if (!form.action || form.action.indexOf('customer') === -1) {
        e.preventDefault();
        const btn = form.querySelector('button');
        if (btn) btn.textContent = '✓ Subscribed';
      }
    });
  });

  /* Smooth scroll for anchor links */
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      if (href.length <= 1) return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
